const chamberMembershipCodeRegex = /([^ ]+) ([^-]+)-(.+)/;

export function UpdateKamaraiAzonosito() {
    const chamberMembershipDatas: JQuery = $('#chamber-membership-editor');
    const selectedChamber: string = $('#' + chamberMembershipDatas.data('chamber-id-field-id') + ' option:selected').text();
    const $architectPermissionField: JQuery = $('#' + chamberMembershipDatas.data('architect-permission-field-id'));
    const $engineerPermissionField: JQuery = $('#' + chamberMembershipDatas.data('engineer-permission-field-id'));
    const $chamberLocationField: JQuery = $('#' + chamberMembershipDatas.data('chamber-location-field-id'));
    const $chamberMemberIdField: JQuery = $('#' + chamberMembershipDatas.data('chamber-memberid-field-id'));
    const $chamberMembershipCode: JQuery = $('#' + chamberMembershipDatas.data('chamber-membership-code-field-id'));

    let permission: any;

    if (selectedChamber === "Magyar Építész Kamara") {
        $architectPermissionField.show();
        $engineerPermissionField.hide();

        permission = $architectPermissionField.val();
    } else {
        $architectPermissionField.hide();
        $engineerPermissionField.show();

        permission = $engineerPermissionField.val();
    }

    const chamberMembershipCode: string = `${permission} ${$chamberLocationField.val()}-${$chamberMemberIdField.val()}`;

    $chamberMembershipCode.val(chamberMembershipCode);
}

export function InitKamara() {
    const chamberMembershipDatas: JQuery = $('#chamber-membership-editor');

    if (chamberMembershipDatas.length === 0) {
        return;
    }

    // Initialize the unobtrusive validator
    // First add the jquery validation rule, then link it to the unobtrusive rule
    $.validator.addMethod("validkamaraiazon", (value, element) => {
        return chamberMembershipCodeRegex.test(value);
    }, "Minden kamarai tagsággal kapcsolatos mező kitöltése kötelező!");

    $.validator.unobtrusive.adapters.addBool('validkamaraiazon');

    const selectedChamberFieldSelector: string = '#' + chamberMembershipDatas.data('chamber-id-field-id');
    const architectPermissionFieldSelector: string = '#' + chamberMembershipDatas.data('architect-permission-field-id');
    const $architectPermissionField: JQuery = $(architectPermissionFieldSelector);
    const engineerPermissionFieldSelector: string = '#' + chamberMembershipDatas.data('engineer-permission-field-id');
    const $engineerPermissionField: JQuery = $(engineerPermissionFieldSelector);
    const chamberLocationFieldSelector: string = '#' + chamberMembershipDatas.data('chamber-location-field-id');
    const $chamberLocationField: JQuery = $(chamberLocationFieldSelector);
    const chamberMembershipCodeFieldSelector: string = '#' + chamberMembershipDatas.data('chamber-membership-code-field-id');
    const $chamberMembershipCode: JQuery = $(chamberMembershipCodeFieldSelector);
    const memberIdFieldSelector: string = '#' + chamberMembershipDatas.data('chamber-memberid-field-id');
    const $chamberMemberIdField = $(memberIdFieldSelector);

    // When should the complete string update
    // Also unfuck the fucked up browser auto complete
    $(`${engineerPermissionFieldSelector}, ${memberIdFieldSelector}`)
        .on('change keyup', (event: JQuery.TriggeredEvent) => {
            UpdateKamaraiAzonosito();
    });

    $(`${selectedChamberFieldSelector}, ${architectPermissionFieldSelector}, ${chamberLocationFieldSelector}`)
        .on('change', (event: JQuery.TriggeredEvent) => {
            UpdateKamaraiAzonosito();
        });

    const azon: string = $chamberMembershipCode.val() as string;
    const parsedResult: RegExpExecArray = chamberMembershipCodeRegex.exec(azon);

    if (parsedResult) {

        const tervJog: string = parsedResult[1];
        const terulet: string = parsedResult[2];
        const tagSzam: string = parsedResult[3];

        $architectPermissionField.val(tervJog);
        $engineerPermissionField.val(tervJog);

        $chamberLocationField.val(terulet);
        $chamberMemberIdField.val(tagSzam);
    }

    UpdateKamaraiAzonosito();
}

jQuery(() => {
    InitKamara();
});
